import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import checkIcon from "../../assets/img/check-icon-white.svg";
import MeterImg from "../../assets/img/metericon.svg"
import Slider from "rc-slider";
import useTranslator from "../../hooks/useTranslator";
import { haveValue, isObject } from "../../helper/common";
import CloseIcon from "../../assets/img/closeIcon.svg"
const DefaultCheckReportModal = ({ isOpen, onClose, user }) => {
  const { _t } = useTranslator();

  const experianData =
    user?.tenant_extra_field_id?.experianJson?.["s:Envelope"]?.["s:Body"]
      ?.GenerarInformeResponse?.GenerarInformeResult?.InformeDelphi4A3;

  console.log(experianData, "experianDataexperianData");
  const DetailsView = ({ label, value, className }) => (
    <div className={`mb-3 ${className ? className : "col-md-4"}`}>
      <div className="info">
        <p>{label}</p>
        <h6>{value}</h6>
      </div>
    </div>
  );
  const max = 100;
  const value =
    experianData?.InformacionDelphi?.ProbabilidadIncumplimientoPorScore;
  const percent = (value / max) * 100;
  const labelOffsetPx = 12;

  return (
    <div className="wrapper-modal" onClick={onClose}>
      <div
        className={`doc-history-popup total-salary-modal default-check-modal ${
          isOpen ? "open" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="doc-history-header">
           <img src={CloseIcon} alt=""
                      className="doc-history-close-btn"
                      onClick={onClose}
                    />
          <h4 className="custom-modal-heading">{_t("defaulterCheckReport")}</h4>
        </div>
        <div className="d-flex justify-content-between align-items-center custom-subheading-wrapper">
          <h6 className="custom-modal-heading custom-subheading">
            {_t("resumenDeRiesgo")}
          </h6>
          <span className="rank-card">
            {_t("rank")}
            <span>{experianData?.InformacionDelphi?.Nota}</span>
          </span>
        </div>
        <div className="skormeter w-100 position-relative">
          <Slider min={0} max={20} defaultValue={3} disabled />
          <div className="slider-labels">
            <span>0%</span>
            <span>25%</span>
            <span>50%</span>
            <span>75%</span>
            <span>100%</span>
          </div>
          <img 
          style={{
            left: `calc(${percent}% - ${labelOffsetPx}px)`,
          }}
          className="meterStatic" src={MeterImg} alt="" />
          <div
            style={{
              left: `calc(${percent}% - ${labelOffsetPx}px)`,
            }}
            className="default-check-modal-percentage"
          >
            {
              experianData?.InformacionDelphi
                ?.ProbabilidadIncumplimientoPorScore
            }
            %
          </div>
        </div>
        <div className="row details-wrapper details-wrapper2">
          <DetailsView label={_t("dniNieNif")} value={user?.dni_nie} />
        </div>
        <h4 className="custom-modal-heading heading-review">
          {_t("resumenDeComportamientoEnPagosEnBureau")}
        </h4>
        <div className="row mb-4">
          {haveValue(experianData?.ResumenCais) &&
            Object.keys(experianData.ResumenCais).map((key) => {
              if (
                key == "NumeroOperacionesImpagadas" ||
                key == "NumeroCuotasImpagadas" ||
                key == "ImporteImpagado" ||
                key == "MaximoImporteImpagado"
              ) {
                return (
                  <div className="col-md-6">
                    <div className="default-check-modal-card">
                      <div>
                        <h4>
                          {_t(key.toLowerCase())}:{" "}
                          {experianData.ResumenCais[key]}
                        </h4>
                      </div>
                      <img src={checkIcon} alt="" />
                    </div>
                  </div>
                );
              } else {
                if (
                  Number(experianData.ResumenCais.NumeroOperacionesImpagadas) >
                    0 ||
                  Number(experianData.ResumenCais.NumeroCuotasImpagadas) > 0
                ) {
                  return (
                    <div className="col-md-6">
                      <div className="default-check-modal-card">
                        <div>
                          <h4>{_t(key.toLowerCase())}: </h4>
                          <span>
                            {isObject(experianData.ResumenCais[key])
                              ? `${experianData.ResumenCais[key].DD}/${experianData.ResumenCais[key].MM}/${experianData.ResumenCais[key].AAAA}`
                              : experianData.ResumenCais[key]}
                          </span>
                        </div>
                        <img src={checkIcon} alt="" />
                      </div>
                    </div>
                  );
                }
              }
            })}
        </div>
      </div>
    </div>
  );
};

export default DefaultCheckReportModal;
